import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    fallbackMessage: { type: String, default: "Link copied to clipboard" },
    failureMessage: { type: String, default: "Unable to copy link" }
  }

  static targets = ["feedback", "source"]

  copy(event) {
    if (event) event.preventDefault()

    const text = this.textValue || this.defaultText()
    if (!text) return

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => this.notify(this.fallbackMessageValue))
        .catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      const successful = document.execCommand("copy")
      this.notify(successful ? this.fallbackMessageValue : this.failureMessageValue)
    } catch (_error) {
      this.notify(this.failureMessageValue)
    } finally {
      document.body.removeChild(textarea)
    }
  }

  notify(message) {
    if (!message) return

    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = message
      this.feedbackTarget.classList.remove("hidden")
      setTimeout(() => {
        this.feedbackTarget.classList.add("hidden")
      }, 2000)
    }

    if (!this.liveRegion) {
      this.liveRegion = document.createElement("div")
      this.liveRegion.setAttribute("role", "status")
      this.liveRegion.setAttribute("aria-live", "polite")
      this.liveRegion.classList.add("sr-only")
      document.body.appendChild(this.liveRegion)
    }
    this.liveRegion.textContent = ""
    setTimeout(() => {
      this.liveRegion.textContent = message
    }, 50)
  }

  defaultText() {
    if (this.hasSourceTarget) {
      const value = this.sourceTarget.value || this.sourceTarget.dataset.copyValue
      if (value) return value
    }
    return ""
  }
}
